export const hasAllPropsDefined = (target: { [key: string]: any }): boolean => {
    const values = Object.keys(target).map(key => target[key]);
    return !values.some(value => value === null || value === undefined);
};
